import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import LandingPage from './pages/LandingPage';
import LegalPage from './pages/legal/LegalPage';

// Login, dashboard, tools and dev previews live in a separate chunk: the public pages stay light.
const AppWorkspace = React.lazy(() => import('./AppWorkspace'));
// Tool pages carry the content renderer: their own chunk too.
const PublicToolsIndexPage = React.lazy(() => import('./pages/public/PublicToolsIndexPage'));
const PublicToolPage = React.lazy(() => import('./pages/public/PublicToolPage'));

const App: React.FC = () => (
    <ErrorBoundary>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/privacy" element={<LegalPage document="privacy" />} />
                <Route path="/cookie" element={<LegalPage document="cookie" />} />
                <Route path="/termini" element={<LegalPage document="termini" />} />
                <Route path="/strumenti" element={<React.Suspense fallback={null}><PublicToolsIndexPage /></React.Suspense>} />
                <Route path="/strumenti/:code" element={<React.Suspense fallback={null}><PublicToolPage /></React.Suspense>} />
                <Route
                    path="/*"
                    element={
                        <React.Suspense fallback={null}>
                            <AppWorkspace />
                        </React.Suspense>
                    }
                />
            </Routes>
        </BrowserRouter>
    </ErrorBoundary>
);

export default App;
